// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"191":"sales-reports","341":"payment-reports","720":"store-designer"}[chunkId] || chunkId) + "." + {"191":"9a1a2146","338":"d0f54fbb","341":"1ef07990","597":"87f62a03","669":"5144182b","715":"876dfcf7","720":"7a835e36","747":"db4811d3","761":"1de5ce2c","848":"51cbe78c","856":"622180cf"}[chunkId] + ".css";
};